"use strict";
exports.__esModule = true;
var React = require("react");
exports.SituationHolder = function (props) {
    // 直接 value を書き換えるので特になにもしない
    var handleChange = function (e) { };
    return (React.createElement("select", { name: props.name, className: "present-search__form-select", value: props.selected.id, onChange: handleChange },
        React.createElement("option", { value: props.selected.id }, props.selected.name)));
};
